import { render, staticRenderFns } from "./AudienceAuthentication.vue?vue&type=template&id=ba77c59a&scoped=true&"
import script from "./AudienceAuthentication.vue?vue&type=script&lang=js&"
export * from "./AudienceAuthentication.vue?vue&type=script&lang=js&"
import style0 from "./AudienceAuthentication.vue?vue&type=style&index=0&id=ba77c59a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba77c59a",
  null
  
)

export default component.exports